import React from "react";
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from "./containers/Login";
import Signup from "./containers/Signup";
import SignupPhone from "./containers/SignupPhone";
import UserDetail from "./containers/UserDetail";
import SignupConfirm from "./containers/SignupConfirm";
import PasswordResetView from "./containers/PasswordResetView";
import NoteNew from "./containers/NoteNew_ckeditor";
import NoteInfo from "./containers/NoteInfo_ckeditor";
import Notes from "./containers/Notes_ckeditor";
import NotFound from "./containers/NotFound";
import Layout from './components/Layout';
import Overview from './components/pages/Overview';
import DAMain from './components/pages/DA/DAMain';
import SGMain from "./components/pages/SG/SGMain";
import UseCaseScenario from "./components/pages/SG/UseCaseScenario";
import ScenarioDevelopment from "./components/pages/SG/ScenarioDevelopment";
import ScenarioManage from "./components/pages/SG/ScenarioManage";
import AcquisitionStatus from "./components/pages/DA/AcquisitionStatus";
import EDMain from "./components/pages/ED/EDMain";
import EAMain from "./components/pages/EA/EAMain";
import EAManage from "./components/pages/EA/EAManage";
import DataManagement from "./components/pages/DA/DataManagement";
import Standard from "./components/pages/Standard";
import MaintenancePage from "./containers/MaintenancePage";

export default function AppRoutes() {
  
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* 홈 페이지 리다이렉트 */}
        <Route index element={<Navigate to="/overview" replace />} />
        {/* Overview */}
        <Route path="/overview" element={<Overview />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/signupphone" element={<SignupPhone />} />
        <Route path="/userdetail" element={<UserDetail />} />
        <Route path="/signupconfirm" element={<SignupConfirm />} />
        <Route path="/auth/reset/:uid/:token" element={PasswordResetView}/>
        <Route path="/notes/new" element={<NoteNew />} />
        <Route path="/notes/:id" element={<NoteInfo />} />
        <Route path="/notes" element={<Notes />} />
        {/* Overview */}
        <Route path="/da" element={<DAMain />} />
        <Route path="/da/overview" element={<DAMain />} />
        <Route path="/da/acquisition-status" element={<AcquisitionStatus />} />
        <Route path="/da/data-management" element={<DataManagement />} />
        <Route path="/sg" element={<SGMain />} />
        <Route path="/sg/overview" element={<SGMain />} />
        <Route path="/sg/usecase-scenario" element={<UseCaseScenario />} />
        <Route path="/sg/scenario-analysis" element={<ScenarioManage />} />
        <Route path="/sg/scenario-development" element={<ScenarioDevelopment />} />
        <Route path="/ed" element={<EDMain />} />
        <Route path="/ed/overview" element={<EDMain />} />
        <Route path="/ea" element={<EAManage />} />
        <Route path="/ea/overview" element={<EAManage />} />
        <Route path="/ea/result-report" element={<EAManage />} />
        <Route path="/standard" element={<Standard />} />
        <Route path="/*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}